import React from 'react';

const FounderMessage = () => {
  return (
    <div className="bg-white py-16 px-4 sm:px-10 md:px-20 lg:px-40">
      <h2 className="text-3xl font-bold text-center mb-10">Founder's Message</h2>
      <div className="flex flex-col md:flex-row items-center md:items-start gap-8">
        <div className="flex-shrink-0">
          <img
            src="/images/ceoimage.jpg" // Make sure to update this image path if needed
            alt="Founder"
            className="rounded-full w-64 h-64 object-cover border-4 border-gray-300"
          />
        </div>
        <div className="text-gray-700 text-justify text-base leading-relaxed max-w-4xl">
          <p className="mb-4">
            PACIFIC BUILDERS (PVT) LTD was founded by Mr. Liaquat Ali Sher with a vision to deliver excellence in construction services across Pakistan. Since its inception, the company has emerged as a leading force in the industry, known for its commitment to quality, integrity, and timely project delivery. Over the years, we have successfully completed numerous high-profile residential, commercial, and institutional projects that stand as a testament to our expertise and dedication.
          </p>
          <p className="mb-4">
            Our mission has always been to redefine construction standards in Pakistan by combining innovative techniques with skilled craftsmanship. At PACIFIC BUILDERS, we understand that construction is not just about structures — it's about building trust, relationships, and sustainable futures. That is why every project we undertake reflects our unwavering focus on precision, safety, and customer satisfaction.
          </p>
          <p className="mb-4">
            We are proud of the team we’ve built and the reputation we’ve earned. It’s our belief that success lies in continuous improvement and a forward-thinking approach. As we move ahead, we remain committed to raising the bar even higher, ensuring that PACIFIC BUILDERS continues to be a symbol of excellence in the construction industry of Pakistan.
          </p>
          <p className="font-semibold mt-6">
            Liaquat Ali Sher
          </p>
          <p className="font-semibold mb-4">
            Founder of PACIFIC BUILDERS (PVT) LTD
          </p>
        </div>
      </div>
    </div>
  );
};


export default FounderMessage;